import { createSlice } from '@reduxjs/toolkit'
import { PURGE } from 'redux-persist'

/* Initial state of the slice */
const initialState = {
  currentStep: 1,
  totalSteps: 2,
  selectedRole: null,
  isUpdateRoleConfirmed: false,
}

const updateUserRoleSlice = createSlice({
  name: 'updateUserRole',
  initialState,
  reducers: {
    setCurrentStep: (state, action) => {
      state.currentStep = action.payload
    },
    setSelectedRole: (state, action) => {
      state.selectedRole = action.payload
    },
    setIsUpdateRoleConfirmed: (state) => {
      state.isUpdateRoleConfirmed = true
    },
    resetUpdateRoleConfirm: (state) => {
      state.isUpdateRoleConfirmed = false
    },
  },
  extraReducers: (builder) => {
    builder
      /* Action which gets triggered
         when running persistor.purge() */
      .addCase(PURGE, () => {
        return initialState
      })
  },
})

export const { setCurrentStep, setSelectedRole, setIsUpdateRoleConfirmed, resetUpdateRoleConfirm } =
  updateUserRoleSlice.actions

export default updateUserRoleSlice.reducer
